import { EllipsisMenuItem } from '@vrplatform/components-legacy';
import { useAuditEffectsModal } from '../modals';

export const EllipsisMenuAuditEffectsItem = ({
  entityId,
}: {
  entityId: string;
}) => {
  const { open: openAuditEffectsModal } = useAuditEffectsModal();

  return (
    <EllipsisMenuItem
      icon="FastForwardIcon"
      onClick={() => {
        openAuditEffectsModal({ entityId });
      }}
    >
      View effects
    </EllipsisMenuItem>
  );
};
